module.exports = __webpack_public_path__ + "img/3c27501487c61c6fe0226a4fb0320793.png";